
import React from "react";
import SearchBar from "./BusinessSearch";

interface BusinessSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  handleSearch: (e: React.FormEvent) => void;
  className?: string;
}

const BusinessSearchBar: React.FC<BusinessSearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  handleSearch,
  className
}) => {
  return (
    <SearchBar
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      handleSearch={handleSearch}
      placeholder="Search businesses, tags, or descriptions..."
      buttonText="Search"
      className={className}
    />
  );
};

export default BusinessSearchBar;
